import { render, staticRenderFns } from "./ScreenAdapter.vue?vue&type=template&id=ae73fc28&scoped=true&"
import script from "./ScreenAdapter.vue?vue&type=script&lang=js&"
export * from "./ScreenAdapter.vue?vue&type=script&lang=js&"
import style0 from "./ScreenAdapter.vue?vue&type=style&index=0&id=ae73fc28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae73fc28",
  null
  
)

export default component.exports